import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const paymentId = searchParams.get('payment_id');
  const pfPaymentId = searchParams.get('pf_payment_id');

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/billing');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-slate-900 py-12 px-4">
      <div className="w-full max-w-md">
        <Card>
          <div className="text-center space-y-6">
            <div className="flex justify-center">
              <CheckCircle className="w-16 h-16 text-green-500 dark:text-green-400" />
            </div>

            <div className="space-y-2">
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                Payment Successful!
              </h1>
              <p className="text-gray-500 dark:text-slate-400">
                Your subscription has been activated. Thank you for choosing Insights.
              </p>
            </div>

            {(paymentId || pfPaymentId) && (
              <div className="p-4 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg text-left space-y-1">
                {paymentId && (
                  <p className="text-sm text-green-800 dark:text-green-300">
                    <span className="font-medium">Payment ID:</span> {paymentId}
                  </p>
                )}
                {pfPaymentId && (
                  <p className="text-sm text-green-800 dark:text-green-300">
                    <span className="font-medium">PayFast Reference:</span> {pfPaymentId}
                  </p>
                )}
              </div>
            )}

            <div className="space-y-3">
              <Button className="w-full" onClick={() => navigate('/billing')}>
                Go to Billing
              </Button>
              <p className="text-sm text-gray-400 dark:text-slate-500">
                Redirecting to billing in 5 seconds...
              </p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
